var $ab7a9097d222cce1$exports = {};
$ab7a9097d222cce1$exports = {
    "pending": `odottaa`
};


export {$ab7a9097d222cce1$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
